"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M18 6.44444C18 7.42578 17.2036 8.22222 16.2222 8.22222C15.2409 8.22222 14.4444 7.42578 14.4444 6.44444C14.4444 5.46311 15.2409 4.66667 16.2222 4.66667C17.2036 4.66667 18 5.46311 18 6.44444ZM11.7778 3.77778C11.7778 4.75911 10.9813 5.55556 10 5.55556C9.01867 5.55556 8.22222 4.75911 8.22222 3.77778C8.22222 2.79644 9.01867 2 10 2C10.9813 2 11.7778 2.79644 11.7778 3.77778ZM11.7778 16.2222C11.7778 17.2036 10.9813 18 10 18C9.01867 18 8.22222 17.2036 8.22222 16.2222C8.22222 15.2409 9.01867 14.4444 10 14.4444C10.9813 14.4444 11.7778 15.2409 11.7778 16.2222ZM18 13.5556C18 14.5369 17.2036 15.3333 16.2222 15.3333C15.2409 15.3333 14.4444 14.5369 14.4444 13.5556C14.4444 12.5742 15.2409 11.7778 16.2222 11.7778C17.2036 11.7778 18 12.5742 18 13.5556ZM5.55556 6.44444C5.55556 7.42578 4.75911 8.22222 3.77778 8.22222C2.79644 8.22222 2 7.42578 2 6.44444C2 5.46311 2.79644 4.66667 3.77778 4.66667C4.75911 4.66667 5.55556 5.46311 5.55556 6.44444ZM5.55556 13.5556C5.55556 14.5369 4.75911 15.3333 3.77778 15.3333C2.79644 15.3333 2 14.5369 2 13.5556C2 12.5742 2.79644 11.7778 3.77778 11.7778C4.75911 11.7778 5.55556 12.5742 5.55556 13.5556ZM12.6667 10C12.6667 11.4729 11.4729 12.6667 10 12.6667C8.52711 12.6667 7.33333 11.4729 7.33333 10C7.33333 8.52711 8.52711 7.33333 10 7.33333C11.4729 7.33333 12.6667 8.52711 12.6667 10Z",
    fill: "#727B7F"
  }));
};